import { render, staticRenderFns } from "./PaginaTabellaRaccordoDestinatari.vue?vue&type=template&id=08c4ad22"
import script from "./PaginaTabellaRaccordoDestinatari.vue?vue&type=script&lang=js"
export * from "./PaginaTabellaRaccordoDestinatari.vue?vue&type=script&lang=js"
import style0 from "./PaginaTabellaRaccordoDestinatari.vue?vue&type=style&index=0&id=08c4ad22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports